<template>
  <div>
    <!-- No workspace selected yet → let user pick one -->
    <WorkSpaceList v-if="showWorkspaceList" @workspace-selected="onWorkspaceSelected" />

    <!-- Workspace chosen → show project list -->
    <ProjectListWorkSpace v-else />
  </div>
</template>

<script>
import WorkSpaceList from "@/modules/settings/Organization/WorkSpace/WorkSpaceList.vue";
import ProjectListWorkSpace from "./ProjectListWorkSpace.vue";

export default {
  name: "WorkspaceEntryPoint",

  components: {
    WorkSpaceList,
    ProjectListWorkSpace,
  },

  data() {
    return {
      // Show workspace picker only when no workspace has been selected yet.
      // workspaceAccess === "false" means we came here without a workspace set.
      // null / undefined / "true" → a workspace is already in context, go straight to projects.
      showWorkspaceList: localStorage.getItem("workspaceAccess") === "false",
    };
  },

  beforeRouteUpdate() {
    // Re-evaluate when the sidebar navigates to this same route again.
    this.showWorkspaceList = localStorage.getItem("workspaceAccess") === "false";
  },

  methods: {
    onWorkspaceSelected() {
      // User just picked a workspace from WorkSpaceList — switch to project list.
      this.showWorkspaceList = false;
    },
  },
};
</script>
